// extracted by mini-css-extract-plugin
export var typingIndicator = "_rd-0";